import { useId } from "react";

import { cn } from "@/lib/utils";

export function LogoIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[83px] w-12.5", className)}
      fill="none"
      viewBox="0 0 50 83"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M47.764.003H1.655a.653.653 0 00-.712.589.656.656 0 00.583.72l35.773 7.572a1.305 1.305 0 011.036 1.307v62.647a1.305 1.305 0 01-1.036 1.308L1.526 81.679a.656.656 0 00-.583.72.653.653 0 00.712.588h46.11c.715 0 1.295-.586 1.295-1.308V1.31c0-.722-.58-1.308-1.296-1.308z"
        fill={`url(#${id})`}
      />
      <ellipse cx="30.579" cy="43.587" fill="#fff" rx="1.743" ry="2.441" />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="49.084"
          x2="49.084"
          y1="82.961"
          y2="0.003"
        >
          <stop stopColor="#90278e" />
          <stop offset="1" stopColor="#ec297b" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function ModalBackIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[11px] w-1.5 text-white", className)}
      fill="none"
      viewBox="0 0 6 11"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.75 1.75L1 5.5l3.75 3.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function MortyIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-9 w-[111px]", className)}
      fill="none"
      viewBox="0 0 111 36"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.654.633H.793A.269.269 0 00.5.879a.273.273 0 00.239.301l14.633 3.17c.251.053.43.283.424.547V31.12a.544.544 0 01-.424.547L.74 34.82a.273.273 0 00-.239.301.269.269 0 00.292.247h18.861c.293 0 .53-.245.53-.548V1.18a.539.539 0 00-.53-.547z"
        fill={`url(#${id}a)`}
      />
      <ellipse cx="12.658" cy="19.158" fill="#fff" rx="0.579" ry="1.158" />
      <path
        d="M46.457 15.106l-4.674 8.2h-.38l-4.673-8.384h-.076v12.341H32.92V8.737h4.2l4.464 8.68h.052l3.266-6.428a4.082 4.082 0 013.634-2.252h1.752v18.526h-3.727V15.106h-.105z"
        fill="#fff"
      />
      <path
        clipRule="evenodd"
        d="M59.556 13.369c-4.32 0-6.95 2.65-6.95 6.947 0 4.297 2.63 6.947 6.95 6.947 4.319 0 6.944-2.65 6.944-6.947 0-4.297-2.625-6.947-6.944-6.947zm2.84 5.893v2.108c0 1.959-1.07 3.065-2.841 3.065-1.772 0-2.848-1.106-2.848-3.065v-2.108c0-1.953 1.082-3.059 2.848-3.059 1.766 0 2.841 1.106 2.841 3.059z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M70.766 24.141v-7.68h-3.109v-3.093h6.97v3.61h.181c.585-1.805 1.853-3.61 4.306-3.61h1.28v3.652h-2.869c-1.723 0-2.921.782-2.921 2.34v4.811h4.434v3.092h-11.38v-3.092l3.108-.03zm14.428-.835v-6.132h-3.641v-3.607h2.365c1.166 0 1.59-.398 1.59-1.616V8.737h3.538v4.83h5.243v3.054h-5.243v7.588h5.243v3.054h-4.97c-2.796 0-4.125-1.646-4.125-3.957zm25.306-9.938l-6.285 14.957-.228.545c-.804 1.941-2.063 3.025-4.42 3.025H96.84v-2.967h2.308c.648 0 1.05-.209 1.248-.62a1.06 1.06 0 00.096-.261l.528-1.397-.45-1.072-5.122-12.204h4.258l2.009 5.615 1.26 3.883h.209l1.2-3.883 2.063-5.615 4.054-.006z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}a`}
          x1="20.194"
          x2="20.194"
          y1="35.356"
          y2="0.633"
        >
          <stop stopColor="#90278e" />
          <stop offset="1" stopColor="#ec297b" />
        </linearGradient>
      </defs>
    </svg>
  );
}
